import { postRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'

const getKeywords = (description: string) =>
  postRestRequest({
    url: api.REST_API_URL + `/classified/generate-keywords`,
    data: {
      description: description,
    },
    transformer: (response: any) => {
      console.log(response)
      return response.data
    },
  })

export default getKeywords
